import type { InferOutput } from "valibot";
import { object } from "valibot";
import { MAX_CHARACTERS_SM, TEXT_CONDITION_KEYS } from "../../constants";
import type { VariableDefinition } from "../Variable";
import { initVariable, VariableBaseSchema } from "../Variable";
import { requireText } from "../../utils/validation/base";
import { keyFromSelector } from "i18next";

const Schema = object({
  ...VariableBaseSchema.entries,
  defaultValue: requireText(MAX_CHARACTERS_SM),
});

export type StringVariableType = InferOutput<typeof Schema>;

const StringVariable: VariableDefinition<StringVariableType> = {
  type: "string",
  icon: "textIcon",
  schema: Schema,
  ruleConditionBehaviour: {
    variant: "text",
    keys: TEXT_CONDITION_KEYS,
  },
  titleKey: keyFromSelector(($) => $.STRING_VARIABLE_LABEL),
};

export default initVariable(StringVariable);
